<section class="stay-connected {{class}}">
  <div class="container">
    <div class="row">
      <div class="col-md-7">
        <h2 [translate]="'stay-connected/stay-tuned'">Fique por dentro</h2>
        <p [translate]="'stay-connected/subscribe'">Assine nossa newsletter e conheça todas as novidades e inovações
          para tornar as cidades mais inteligentes.</p>
        <a (click)="toggleShowDiv('news')" *ngIf="animationState == 'out'"
           class="register-link">{{'stay-connected/register' | translate}} <i class="fal fa-chevron-right"></i></a>
        <div [@slideInOut]="animationState" class="formNews">
          <form (submit)="sendContact(news, true)" [formGroup]="news">
            <mat-form-field class="full-width">
              <mat-label [translate]="'painel-dashboard/email'" class="fields-item--label" for="email">Email</mat-label>
              <input formControlName="email" id="email" matInput required type="email">
              <!-- <mat-error *ngIf="isFieldValid('name')" [translate]="'painel-dashboard/field-required'">Field Required</mat-error> -->
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label [translate]="'painel-dashboard/name'" class="fields-item--label" for="name">Name</mat-label>
              <input formControlName="name" id="name" matInput required type="text">
              <!-- <mat-error *ngIf="isFieldValid('name')" [translate]="'painel-dashboard/field-required'">Field Required</mat-error> -->
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label [translate]="'payment/city'" class="fields-item--label" for="city">Cidade</mat-label>
              <input formControlName="city" id="city" matInput required type="text">
              <!-- <mat-error *ngIf="isFieldValid('name')" [translate]="'painel-dashboard/field-required'">Field Required</mat-error> -->
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label [translate]="'painel-dashboard/profile'" class="fields-item--label" for="profile">Perfil
              </mat-label>
              <mat-select disableOptionCentering formControlName="profile" id="profile" name="profile">
                <mat-option matInput
                            value="Administrador Público">{{'create-account/PUBLIC_ADMINISTRATOR' | translate}}</mat-option>
                <mat-option matInput
                            value="Provedor de Soluções">{{'create-account/SOLUTION_PROVIDER' | translate}}</mat-option>
                <mat-option matInput value="Cidadão">{{'create-account/CITIZEN' | translate}}</mat-option>
              </mat-select>
            </mat-form-field>
            <input [disabled]="news.status == 'INVALID'" class="btn btn-gradient" type="submit" value="Enviar">
          </form>
        </div>
      </div>
      <div class="col-md-5">
        <div class="contact-form">
          <div class="form-title">
            <h3 [translate]="'stay-connected/try-out'">Receba uma demonstração</h3>
            <p [translate]="'stay-connected/contact-us'">Entre em contato para saber mais detalhes de nossa metodologia
              processos de diagnósticos e planos de acesso.</p>
          </div>
          <form (submit)="sendContact(form)" [formGroup]="form">
            <div class="form-group">
              <mat-form-field class="full-width">
                <mat-label [translate]="'painel-dashboard/name'" class="fields-item--label" for="name">Name</mat-label>
                <input formControlName="name" id="name" matInput required type="text">
                <!-- <mat-error *ngIf="isFieldValid('name')" [translate]="'painel-dashboard/field-required'">Field Required</mat-error> -->
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field class="full-width">
                <mat-label [translate]="'painel-dashboard/email'" class="fields-item--label" for="email">Email
                </mat-label>
                <input formControlName="email" id="email" matInput required type="email">
                <!-- <mat-error *ngIf="isFieldValid('name')" [translate]="'painel-dashboard/field-required'">Field Required</mat-error> -->
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field class="full-width">
                <mat-label [translate]="'payment/city'" class="fields-item--label" for="city">Cidade</mat-label>
                <input formControlName="city" id="city" matInput required type="text">
                <!-- <mat-error *ngIf="isFieldValid('name')" [translate]="'painel-dashboard/field-required'">Field Required</mat-error> -->
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field class="full-width">
                <mat-label [translate]="'painel-dashboard/profile'" class="fields-item--label" for="profile">Perfil
                </mat-label>
                <mat-select disableOptionCentering formControlName="profile" id="profile" name="profile">
                  <mat-option matInput
                              value="Administrador Público">{{'create-account/PUBLIC_ADMINISTRATOR' | translate}}</mat-option>
                  <mat-option matInput
                              value="Provedor de Soluções">{{'create-account/SOLUTION_PROVIDER' | translate}}</mat-option>
                  <mat-option matInput value="Cidadão">{{'create-account/CITIZEN' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <input [disabled]="form.status == 'INVALID'" class="btn btn-gradient" type="submit" value="Enviar">
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
